import { useEventListener } from "usehooks-ts";

export const useUnhandledTextInput = (onInput: (ev: KeyboardEvent) => void) =>
  useEventListener(
    "keydown",
    (ev) => {
      const event = ev as KeyboardEvent;
      const activeElement = document.activeElement;
      if (activeElement && activeElement.tagName !== "BODY") {
        return;
      }
      // We only trigger edit-mode on printable characters, but not space (Space key is used to go into panning mode with mouse)
      // - modifier keys mean shortcuts, so ignore those as well (shift not a modifier)
      const modifierKeyClicked = event.ctrlKey || event.metaKey || event.altKey;
      const isPrintableChar = event.key.length === 1 && event.key != " ";
      if (!modifierKeyClicked && isPrintableChar) {
        onInput(event);
      }
    },
    undefined, // undefined will go to window
    true // capture phase, before anything else basically
  );
